import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import './PartnersSection.css';

const PartnersSection = () => {
  const partners = [
    {
      name: 'Nicodemus GmbH',
      description: 'Beratung Immobilien Treuhand (BIT) - Liegenschaftenverwaltungen, Treuhanddienstleistungen',
      url: 'https://www.nicodemus-bit.swiss/',
      icon: '🏢',
      color: '#4A90E2'
    },
    {
      name: 'Malergeschäft Labbiento GmbH',
      description: 'Maler-/Gipser-Arbeiten, Stucco Veneziano',
      url: 'http://www.maler-labbiento.ch/',
      icon: '🎨',
      color: '#E94B3C'
    },
    {
      name: 'Kindermuseum Baden',
      description: 'Kinderkultur in einer Gründervilla - zwanzig «Wunderkammern» zum Entdecken, Spielen und Ausprobieren',
      url: 'http://www.kindermuseum.ch/',
      icon: '🎭',
      color: '#9B59B6'
    }
  ];

  return (
    <section className="partners-section">
      <div className="partners-container">
        <div className="section-header">
          <span className="section-badge partners-badge">Unsere Partner</span>
          <h2 className="section-title">
            Gemeinsam <span className="highlight-text-partners">stark</span>
          </h2>
          <p className="section-description">
            Diese wunderbaren Partner haben uns über die Jahre begleitet.
            <br />
            Wir danken für die tolle Zusammenarbeit!
          </p>
        </div>

        <div className="partners-grid">
          {partners.map((partner, index) => (
            <Card key={index} className="partner-card" style={{ '--partner-color': partner.color }}>
              <CardContent className="partner-content">
                <div className="partner-icon-wrapper">
                  <div className="partner-icon">{partner.icon}</div>
                </div>
                <h3 className="partner-name">{partner.name}</h3>
                <p className="partner-description">{partner.description}</p>
                <a 
                  href={partner.url} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="partner-link"
                >
                  <span>Webseite besuchen</span>
                  <ExternalLink size={18} />
                </a>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="partners-thank-you">
          <h3>💛 Dankeschön!</h3>
          <p>
            An alle Partner, Kunden und Freunde, die uns über 48 Jahre die Treue gehalten haben.
            <br />
            Ihr wart der Grund, warum wir jeden Tag gerne zur Arbeit kamen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;